const t = "{{currentTime}} ud af {{duration}}", n = "Søgeresultat {{current}} af {{total}}", s = "Ingen resultater fundet", e = "{{count}} resultat fundet", o = "{{count}} resultater fundet", r = 'Afspiller fra $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) og $t(SECONDS, { "count": {{seconds}} }).', A = 'Afspiller fra $t(MINUTES, { "count": {{minutes}} }) og $t(SECONDS, { "count": {{seconds}} }).', i = 'Afspiller fra $t(SECONDS, { "count": {{seconds}} }).', E = "Fejl ved lagring af ændringer i transskriptionen.", T = "Transskriptionslinje ved {{time}}. Indhold er: {{text}}.", c = 'Beholder til transskriptionslinjer. Der er $t(TRANSCRIPT_LINES, { "count": {{count}} }) i denne beholder. For at navigere inde i denne beholder skal du bruge pil ned-tasten.', S = "Gemmer ændringer ...", _ = "Ændringer gemt i transskriptionen.", l = "Knappen Opdater undertekster er nu tilgængelig.", N = "Handling", R = "Tilføj anmærkning {{time}}", I = "Tilføj spørgsmål ved {{time}}", O = "Anmærkninger", a = "Auto", d = "Auto ({{quality}})", g = "Tilbage", C = "Billedtekster", u = "Billedtekstsprog", P = "Styring af billedtekster", U = "Slet {{language}}", L = "Skriftstørrelse", k = "Billedtekstsprog: {{language}}", p = "{{language}} (automatisk)", D = "Ryd søgning", m = "Luk", M = "Kommentarer", f = "Fortsæt", G = "Reducer afspilningshastigheden", Y = "Sænk lydstyrken med {{percent}}%", h = "Pil ned", H = "Luk transskriptionseditoren", v = "Opdater undertekster", B = "Fejl!", V = "Gemmer ...", b = "Gemt!", F = "Rediger transskription", K = "Tekst må ikke være tom!", j = "Fuld skærm", y = "{{count}} time", W = "{{count}} timer", $ = "Øg afspilningshastigheden", Q = "Øg lydstyrken med {{percent}}%", J = "Inverter farver", x = "Gå til en bestemt procentdel (1-10 %, 2-20 % osv.)", Z = "Gå til start", X = "Handlinger for {{title}}", q = "Genvejstaster", w = "Sprog", z = "Venstre pil", tt = "Hovedmenu", nt = "{{count}} minut", st = "{{count}} minutter", et = "Tilbagehold feedback", ot = "Tilbageholdt", rt = "Næste billedtekstsprog", At = "Næste søgeresultat", it = "Slået fra", Et = "Oven på", Tt = "Åbn anmærkning ved {{time}}", ct = "Åbn gennemført test ved {{time}}", St = "Åbn test ved {{time}}", _t = "Pause", lt = "Afspil", Nt = "Afspilningshastighed", Rt = "Afspilningshastighed: {{speed}}x", It = "Forrige billedtekstsprog", Ot = "Forrige søgeresultat", at = "Kvalitet", dt = "Kvalitetsmenu", gt = "Genspil", Ct = "Nulstil afspilningshastighed", ut = "Højre pil", Pt = "Søg i transskription", Ut = "{{count}} sekund", Lt = "{{count}} sekunder", kt = "Søg baglæns: {{seconds}} sekunder", pt = "Søg fremad: {{seconds}} sekunder", Dt = "Indstillinger", mt = "Genvej", Mt = "Mediedetaljer og værktøjer", ft = "Mellemrum", Gt = "Menu for afspilningshastighed", Yt = "Start automatisk rulning", ht = "Slå billedtekster til/fra", Ht = "Slå lydløs til/fra", vt = "Slå afspil/pause til fra", Bt = "er {{count}} transskriptionslinje", Vt = "er {{count}} transskriptionslinjer", bt = "Indlæser transskription ...", Ft = "Vi kunne ikke indlæse transskription.", Kt = "Transskriptionsmuligheder", jt = "Prøv igen", yt = "Transskription ikke tilgængelig", Wt = "Pil op", $t = "Videoindstillinger", Qt = "Lydstyrke", Jt = "Lydstyrke: {{volume}}%", xt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: n,
  A11Y_SEARCH_NO_RESULTS: s,
  A11Y_SEARCH_RESULTS_FOUND: e,
  A11Y_SEARCH_RESULTS_FOUND_other: o,
  A11Y_TIMESTAMP_JUMP_HOURS: r,
  A11Y_TIMESTAMP_JUMP_MINUTES: A,
  A11Y_TIMESTAMP_JUMP_SECONDS: i,
  A11Y_TRANSCRIPT_ERROR: E,
  A11Y_TRANSCRIPT_LINE: T,
  A11Y_TRANSCRIPT_LINES: c,
  A11Y_TRANSCRIPT_SAVING: S,
  A11Y_TRANSCRIPT_SUCCESS: _,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: l,
  ACTION: N,
  ADD_ANNOTATION_AT: R,
  ADD_QUESTION_AT: I,
  ANNOTATIONS: O,
  AUTO: a,
  AUTO_QUALITY: d,
  BACK: g,
  CAPTIONS: C,
  CAPTIONS_LANGUAGE: u,
  CAPTIONS_MANAGE: P,
  CAPTION_DELETE: U,
  CAPTION_FONT_SIZE: L,
  CAPTION_LANGUAGE: k,
  CAPTION_LANGUAGE_AUTOMATIC: p,
  CLEAR_SEARCH: D,
  CLOSE: m,
  COMMENTS: M,
  CONTINUE: f,
  DECREASE_PLAYBACK_SPEED: G,
  DECREASE_VOLUME: Y,
  DOWN_ARROW: h,
  EDIT_CLOSE: H,
  EDIT_CONFIRM: v,
  EDIT_ERROR: B,
  EDIT_SAVING: V,
  EDIT_SUCCESS: b,
  EDIT_TRANSCRIPT: F,
  EDIT_VALIDATION_ERROR: K,
  FULLSCREEN: j,
  HOURS: y,
  HOURS_other: W,
  INCREASE_PLAYBACK_SPEED: $,
  INCREASE_VOLUME: Q,
  INVERT_COLORS: J,
  JUMP_TO_PERCENTAGE: x,
  JUMP_TO_START: Z,
  KEBAB_MENU: X,
  KEYBOARD_SHORTCUTS: q,
  LANGUAGE: w,
  LEFT_ARROW: z,
  MAIN_MENU: tt,
  MINUTES: nt,
  MINUTES_other: st,
  MUTE: et,
  MUTED: ot,
  NEXT_CAPTION_LANGUAGE: rt,
  NEXT_HIT: At,
  OFF: it,
  ON_TOP: Et,
  OPEN_ANNOTATION_AT: Tt,
  OPEN_COMPLETED_QUIZ_AT: ct,
  OPEN_QUIZ_AT: St,
  PAUSE: _t,
  PLAY: lt,
  PLAYBACK_SPEED: Nt,
  PLAYBACK_SPEED_MESSAGE: Rt,
  PREVIOUS_CAPTION_LANGUAGE: It,
  PREVIOUS_HIT: Ot,
  QUALITY: at,
  QUALITY_MENU: dt,
  REPLAY: gt,
  RESET_PLAYBACK_SPEED: Ct,
  RIGHT_ARROW: ut,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Pt,
  SECONDS: Ut,
  SECONDS_other: Lt,
  SEEK_BACKWARD: kt,
  SEEK_FORWARD: pt,
  SETTINGS: Dt,
  SHORTCUT: mt,
  SIDEBAR: Mt,
  SPACE: ft,
  SPEED_MENU: Gt,
  START_AUTOSCROLL: Yt,
  TOGGLE_CAPTIONS: ht,
  TOGGLE_MUTED: Ht,
  TOGGLE_PLAY_PAUSE: vt,
  TRANSCRIPT_LINES: Bt,
  TRANSCRIPT_LINES_other: Vt,
  TRANSCRIPT_LOADING: bt,
  TRANSCRIPT_LOAD_ERROR: Ft,
  TRANSCRIPT_OPTIONS: Kt,
  TRANSCRIPT_RETRY: jt,
  TRANSCRIPT_UNAVAILABLE: yt,
  UP_ARROW: Wt,
  VIDEO_SETTINGS: $t,
  VOLUME: Qt,
  VOLUME_VALUE: Jt
};
export {
  t as A11Y_DURATION,
  n as A11Y_SEARCH_HITS,
  s as A11Y_SEARCH_NO_RESULTS,
  e as A11Y_SEARCH_RESULTS_FOUND,
  o as A11Y_SEARCH_RESULTS_FOUND_other,
  r as A11Y_TIMESTAMP_JUMP_HOURS,
  A as A11Y_TIMESTAMP_JUMP_MINUTES,
  i as A11Y_TIMESTAMP_JUMP_SECONDS,
  E as A11Y_TRANSCRIPT_ERROR,
  T as A11Y_TRANSCRIPT_LINE,
  c as A11Y_TRANSCRIPT_LINES,
  S as A11Y_TRANSCRIPT_SAVING,
  _ as A11Y_TRANSCRIPT_SUCCESS,
  l as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  N as ACTION,
  R as ADD_ANNOTATION_AT,
  I as ADD_QUESTION_AT,
  O as ANNOTATIONS,
  a as AUTO,
  d as AUTO_QUALITY,
  g as BACK,
  C as CAPTIONS,
  u as CAPTIONS_LANGUAGE,
  P as CAPTIONS_MANAGE,
  U as CAPTION_DELETE,
  L as CAPTION_FONT_SIZE,
  k as CAPTION_LANGUAGE,
  p as CAPTION_LANGUAGE_AUTOMATIC,
  D as CLEAR_SEARCH,
  m as CLOSE,
  M as COMMENTS,
  f as CONTINUE,
  G as DECREASE_PLAYBACK_SPEED,
  Y as DECREASE_VOLUME,
  h as DOWN_ARROW,
  H as EDIT_CLOSE,
  v as EDIT_CONFIRM,
  B as EDIT_ERROR,
  V as EDIT_SAVING,
  b as EDIT_SUCCESS,
  F as EDIT_TRANSCRIPT,
  K as EDIT_VALIDATION_ERROR,
  j as FULLSCREEN,
  y as HOURS,
  W as HOURS_other,
  $ as INCREASE_PLAYBACK_SPEED,
  Q as INCREASE_VOLUME,
  J as INVERT_COLORS,
  x as JUMP_TO_PERCENTAGE,
  Z as JUMP_TO_START,
  X as KEBAB_MENU,
  q as KEYBOARD_SHORTCUTS,
  w as LANGUAGE,
  z as LEFT_ARROW,
  tt as MAIN_MENU,
  nt as MINUTES,
  st as MINUTES_other,
  et as MUTE,
  ot as MUTED,
  rt as NEXT_CAPTION_LANGUAGE,
  At as NEXT_HIT,
  it as OFF,
  Et as ON_TOP,
  Tt as OPEN_ANNOTATION_AT,
  ct as OPEN_COMPLETED_QUIZ_AT,
  St as OPEN_QUIZ_AT,
  _t as PAUSE,
  lt as PLAY,
  Nt as PLAYBACK_SPEED,
  Rt as PLAYBACK_SPEED_MESSAGE,
  It as PREVIOUS_CAPTION_LANGUAGE,
  Ot as PREVIOUS_HIT,
  at as QUALITY,
  dt as QUALITY_MENU,
  gt as REPLAY,
  Ct as RESET_PLAYBACK_SPEED,
  ut as RIGHT_ARROW,
  Pt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Ut as SECONDS,
  Lt as SECONDS_other,
  kt as SEEK_BACKWARD,
  pt as SEEK_FORWARD,
  Dt as SETTINGS,
  mt as SHORTCUT,
  Mt as SIDEBAR,
  ft as SPACE,
  Gt as SPEED_MENU,
  Yt as START_AUTOSCROLL,
  ht as TOGGLE_CAPTIONS,
  Ht as TOGGLE_MUTED,
  vt as TOGGLE_PLAY_PAUSE,
  Bt as TRANSCRIPT_LINES,
  Vt as TRANSCRIPT_LINES_other,
  bt as TRANSCRIPT_LOADING,
  Ft as TRANSCRIPT_LOAD_ERROR,
  Kt as TRANSCRIPT_OPTIONS,
  jt as TRANSCRIPT_RETRY,
  yt as TRANSCRIPT_UNAVAILABLE,
  Wt as UP_ARROW,
  $t as VIDEO_SETTINGS,
  Qt as VOLUME,
  Jt as VOLUME_VALUE,
  xt as default
};
